"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TreatmentPlanStatusNote_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var Note_1 = require("./Note");
var TreatmentPlan_1 = require("./TreatmentPlan");
var TreatmentPlanStatusNote_Factory = /** @class */ (function () {
    function TreatmentPlanStatusNote_Factory() {
    }
    TreatmentPlanStatusNote_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Note: Note_1.Note_Factory.CreateIncoming(model.Note),
            NoteId: model.NoteId,
            NoteTakenOn: Date_Factory_1.Date_Factory.CreateIncoming(model.NoteTakenOn),
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            TreatmentPlan: TreatmentPlan_1.TreatmentPlan_Factory.CreateIncoming(model.TreatmentPlan),
            TreatmentPlanId: model.TreatmentPlanId,
        };
        return result;
    };
    TreatmentPlanStatusNote_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Note: Note_1.Note_Factory.CreateOutgoing(model.Note),
            NoteId: model.NoteId,
            NoteTakenOn: Date_Factory_1.Date_Factory.CreateOutgoing(model.NoteTakenOn),
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            TreatmentPlan: TreatmentPlan_1.TreatmentPlan_Factory.CreateOutgoing(model.TreatmentPlan),
            TreatmentPlanId: model.TreatmentPlanId,
        };
        return result;
    };
    return TreatmentPlanStatusNote_Factory;
}());
exports.TreatmentPlanStatusNote_Factory = TreatmentPlanStatusNote_Factory;
